import { Input } from "antd";
import React from "react";
import styled, { css } from "styled-components";

import { Colors, Fonts } from "../../../config";

const StyledInput = styled(Input).attrs({ className: "inputField" })`
  ${(props) =>
    !props.password
      ? css`
&[type], input {
    background-color: ${props.bgColor ? props.bgColor : Colors.White};
    color: ${props.color ? props.color : "gray"};
    border: none;
    //grey 66;
    border-radius: 0;
}
& .ant-input-disabled{
  color:black;
}
&[type]:hover, input:hover {
  text-decoration:none
  border: none;
 
 border-color: grey !important;
}
&[type]:focus, input:focus {
  border: none;
 
  border-color: grey !important;
  /* box-shadow: 0 0 0 2px red66; */
  box-shadow: none;
}
/* * {
  color: grey;
} */
`
      : css`
          & {
            background-color: ${Colors.White};
            border: none;
            border-bottom: 1px solid #f5f5f5;
            border-radius: 10;
            align-items: center;
          }
          &:before {
            width: 0;
            visibility: hidden;
            content: "\a0";
            line-height: 0;
          }
          input {
            color: grey;
          }
          &:hover {
            border: none;
            // border-bottom: 1px solid grey;
            // border-color: grey !important;
          }
          &:focus,
          &.ant-input-affix-wrapper-focused {
            border: none;
            // border-bottom: 1px solid grey;
            // border-color: grey !important;
            /* box-shadow: 0 0 0 2px 66; */
            box-shadow: none;
          }
          * {
            color: grey;
          }
        `}/* &.lightBg {
    background-color: rgba(255, 255, 255, 0.5);
} */
`;

const InputWrapper = (props) => {
  return props.password ? (
    <>
      {props.label && (
        <label
          style={{
            textAlign: "left",
            color: Colors.TextColor,
            fontFamily: Fonts["Poppins-Regular"],
            fontSize: "16px",
          }}
        >
          {props.label}
        </label>
      )}
      <StyledInput as={Input.Password} {...props}></StyledInput>
    </>
  ) : (
    <>
      {props.label && (
        <label
          style={{
            textAlign: "left",
            color: Colors.TextColor,
            fontFamily: Fonts["Poppins-Regular"],
            fontSize: "16px",
          }}
        >
          {props.label}
        </label>
      )}
      <StyledInput {...props} >{props.children}</StyledInput>
    </>
  );
};

export default InputWrapper;
